<template>
    <v-row>
        <v-col cols="12">
            <v-divider class="mb-5"></v-divider>
            <div class="d-flex justify-space-between align-center">
                <span class="title">
                    <v-icon>check_box</v-icon>
                    {{ $t('demand.form.tasks.data') }}
                </span>
                <v-spacer></v-spacer>
                <v-text-field
                    v-if="setup.isEmployee"
                    v-model="setup.tasks.item"
                    @keyup.enter.self.prevent="saveTask()"
                    :label="$t('demand.form.tasks.task.label')"
                    hide-details
                    filled
                >
                    <template v-slot:append-outer>
                        <v-btn
                            color="primary"
                            :loading="setup.tasks.loading"
                            :disabled="setup.tasks.loading"
                            @click="saveTask()"
                        >
                            {{ $t('common.add') }}
                            <span slot="loader" class="custom-loader">
                                <v-icon light>cached</v-icon>
                            </span>
                        </v-btn>
                    </template>
                </v-text-field>
            </div>
        </v-col>
        <v-col cols="12">
            <v-list dense>
                <template v-if="setup.isEmployee">
                    <draggable
                        v-model="demand.demandTask.results"
                        :disabled="setup.tasks.loading"
                        group="tasks"
                        @start="clearHandleChange()"
                        @end="drag=false"
                        @change="handleChange($event, demand.demandTask.results)"
                    >
                        <transition-group>
                            <template v-for="(item, index) in demand.demandTask.results" >
                                <!-- <v-list-item :key="index" v-if="!item.isDone || viewTaks" :disabled="setup.tasks.loading"> -->
                                <v-list-item :key="index" v-if="!item.isDone || viewTaks">
                                    <v-list-item-action @click="completeTask(item)">
                                        <v-checkbox
                                            v-model="item.isDone"
                                            readonly
                                            :disabled="setup.tasks.loading"
                                        ></v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content class="task-item" :class="{ checked: item.isDone }">
                                        <v-list-item-title>{{item.task}}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="error"
                                            text
                                            @click.prevent="deleteTask(index, item)"
                                            :disabled="setup.tasks.loading"
                                        >
                                            {{ $t('common.remove') }}
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                        </transition-group>
                    </draggable>
                </template>
                <template v-else v-for="(item, index) in demand.demandTask.results">
                    <v-list-item :key="index" v-if="!item.isDone || viewTaks">
                        <v-list-item-action>
                            <v-checkbox
                                v-model="item.isDone"
                                readonly
                            ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content class="task-item" :class="{ checked: item.isDone }">
                            <v-list-item-title>{{item.task}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-col>
        <v-col cols="12" md="6">
            <v-btn
                v-if="hasTasksIsDone"
                color="primary"
                @click="toggleTasksDone()"
                small
            >
                {{viewTaks ? $t('demand.form.tasks.hideDoneTasks') : $t('demand.form.tasks.showDoneTasks')}}
            </v-btn>
        </v-col>
        <v-col cols="12" md="6" class="text-right">
            <v-btn
                v-if="hasMoreTasks"
                :loading="setup.tasks.loading"
                :disabled="setup.tasks.loading"
                @click="getTask()"
                small
                text
            >
                {{ $t('common.loadMore') }}
                <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                </span>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import API from '@/api'
import draggable from 'vuedraggable'

export default {
    name: 'demand-task',
    props: ['setup', 'demand'],
    components: {
        draggable
    },
    data () {
        return {
            viewTaks: false
        }
    },
    computed: {
        hasTasksIsDone () {
            if (this.demand.demandTask.results === undefined) return
            for (const task of this.demand.demandTask.results) {
                if (task.isDone) {
                    return true
                }
            }
            return false
        },
        hasMoreTasks () {
            if (this.demand.demandTask.results === undefined) return
            if (this.demand.demandTask.results.length < this.demand.demandTask.count) {
                if (this.hasTasksIsDone && !this.viewTaks) {
                    return false
                } else if (this.hasTasksIsDone && this.viewTaks) {
                    return true
                } else {
                    return true
                }
            } else {
                return false
            }
        }
    },
    methods: {
        clearHandleChange () {
            if (this.handleCHangeTimeout !== undefined) clearTimeout(this.handleCHangeTimeout)
            this.drag = true
        },
        handleChange (e) {
            if (this.handleCHangeTimeout !== undefined) clearTimeout(this.handleCHangeTimeout)
            this.handleCHangeTimeout = setTimeout(() => {
                let endpoint = API.EndPoints.reorderTask
                let finishedTasks = []
                let notFinishedTasks = []
                let limit = this.demand.demandTask.results.length
                for (let index = 0; index < this.demand.demandTask.results.length; index++) {
                    this.demand.demandTask.results[index].order = index
                    if (this.demand.demandTask.results[index].isDone === true) finishedTasks.push(this.demand.demandTask.results[index])
                    if (this.demand.demandTask.results[index].isDone === false) notFinishedTasks.push(this.demand.demandTask.results[index])
                }
                finishedTasks = finishedTasks.sort((a, b) => (a.order > b.order) ? 1 : -1)
                notFinishedTasks = notFinishedTasks.sort((a, b) => (a.order > b.order) ? 1 : -1)
                this.demand.demandTask.results = [...notFinishedTasks, ...finishedTasks]
                const params = {
                    demandTask: this.demand.demandTask.results
                }
                new API(endpoint, params).request().then(response => {
                    window.getApp.refreshDemands = true
                    this.getTask(true, limit)
                }, (e) => {
                    this.$helpers.requestError(e)
                })
            }, 999)
        },
        getTask (refresh = null, limit = null, skip = null) {
            this.setup.tasks.loading = true
            if (refresh) {
                this.demand.demandTask.count = 0
                skip = 0
            }
            let endpoint = API.EndPoints.getTask
            const params = {
                objectId: this.demand.objectId,
                limit: limit || 15,
                skip: (skip === null) ? this.demand.demandTask.results.length : skip
            }
            new API(endpoint, params).request().then(response => {
                this.demand.demandTask.count = response.data.result.count
                if (refresh) {
                    this.demand.demandTask.results = []
                }
                this.demand.demandTask.results = [...this.demand.demandTask.results, ...response.data.result.results]
                this.setup.tasks.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        saveTask () {
            window.getApp.refreshDemands = true;
            (!this.setup.isEdit) ? this.addTask() : this.addTaskRest()
        },
        addTask () {
            if (this.setup.tasks.item) {
                this.demand.demandTask.results.push({
                    task: this.setup.tasks.item,
                    billingLevel: 0,
                    isDone: false,
                    order: this.demand.demandTask.results.length
                })
                this.setup.tasks.item = undefined
            }
        },
        addTaskRest () {
            if (this.setup.tasks.item) {
                this.setup.tasks.loading = true
                let endpoint = API.EndPoints.createTask
                const params = {
                    demand: { __type: 'Pointer', className: 'Demand', objectId: this.demand.objectId },
                    client: { __type: 'Pointer', className: 'Client', objectId: this.demand.client.objectId },
                    responsible: { __type: 'Pointer', className: 'UserCompany', objectId: JSON.parse(localStorage.currentUserCompany).objectId },
                    task: this.setup.tasks.item,
                    billingLevel: 0,
                    isDone: false,
                    order: this.demand.demandTask.results.length
                }

                if (this.demand.department !== undefined) {
                    params.client = { __type: 'Pointer', className: 'Client', objectId: this.demand.department.objectId }
                }

                new API(endpoint, params).request().then(response => {
                    params.objectId = response.data.objectId
                    this.demand.demandTask.results.push(params)
                    this.setup.tasks.item = undefined
                    this.getTask(true, this.demand.demandTask.results.length, 0)
                    this.$emit('event-interaction')
                }, (e) => {
                    this.$helpers.requestError(e)
                })
            }
        },
        completeTask (task) {
            window.getApp.refreshDemands = true;
            (!this.setup.isEdit) ? this.updateTask(task) : this.updateTaskRest(task)
        },
        updateTask (task) {
            task.isDone = !task.isDone
        },
        updateTaskRest (task) {
            window.getApp.refreshDemands = true
            let endpoint = API.EndPoints.editTask
            endpoint.id = task.objectId
            let params = {
                isDone: !task.isDone,
                objectId: task.objectId,
                dateConclusion: (!task.isDone === true) ? { '__type': 'Date', 'iso': new Date().toISOString() } : { __op: 'Delete' },
                responsible: { __type: 'Pointer', className: 'UserCompany', objectId: JSON.parse(localStorage.currentUserCompany).objectId }
            }
            new API(endpoint, params).request().then(response => {
                this.getTask(true, this.demand.demandTask.results.length, 0)
                this.$emit('event-interaction')
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        deleteTask (index, task) {
            window.getApp.refreshDemands = true;
            (!this.setup.isEdit) ? this.removeTask(index) : this.removeTaskRest(task, index)
        },
        removeTask (index) {
            this.demand.demandTask.results.splice(index, 1)
        },
        removeTaskRest (params, index) {
            window.getApp.refreshDemands = true
            let endpoint = API.EndPoints.deleteTask
            endpoint.id = params.objectId
            new API(endpoint).request().then(response => {
                this.removeTask(index)
                this.handleChange(null, this.demand.demandTask.results)
                this.$emit('event-interaction')
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        toggleTasksDone () {
            this.viewTaks = !this.viewTaks
        }
    }
}
</script>

<style lang="stylus" scoped>
    .task-item.checked
        .v-list-item__title
            text-decoration: line-through
    .v-list-item:hover
        background-color: #eeeeee
        cursor: pointer
</style>
